import { createSvgIcon } from '@mui/material';

export const Cross =
    createSvgIcon(
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.25" y="0.250015" width="34.5" height="34.5" rx="7.75" fill="#FFEBEB" stroke="#DDB9B9" stroke-width="0.5" />
            <path d="M17.5002 9.58335C13.1381 9.58335 9.5835 13.1379 9.5835 17.5C9.5835 21.8621 13.1381 25.4167 17.5002 25.4167C21.8622 25.4167 25.4168 21.8621 25.4168 17.5C25.4168 13.1379 21.8622 9.58335 17.5002 9.58335ZM20.1602 19.3208C20.3897 19.5504 20.3897 19.9304 20.1602 20.16C20.0414 20.2788 19.891 20.3342 19.7406 20.3342C19.5902 20.3342 19.4397 20.2788 19.321 20.16L17.5002 18.3392L15.6793 20.16C15.5606 20.2788 15.4102 20.3342 15.2597 20.3342C15.1093 20.3342 14.9589 20.2788 14.8402 20.16C14.6106 19.9304 14.6106 19.5504 14.8402 19.3208L16.661 17.5L14.8402 15.6792C14.6106 15.4496 14.6106 15.0696 14.8402 14.84C15.0697 14.6104 15.4497 14.6104 15.6793 14.84L17.5002 16.6608L19.321 14.84C19.5506 14.6104 19.9306 14.6104 20.1602 14.84C20.3897 15.0696 20.3897 15.4496 20.1602 15.6792L18.3393 17.5L20.1602 19.3208Z" fill="#F86060" />
        </svg>

        ,
        "Cross",
    )

export default Cross;
